import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Accordion, AccordionItem, MenuSeparator, Typography } from '@getgo/chameleon-web-react-wrapper';

import { useAppSelector } from 'hooks';
import useViewPortSize from 'hooks/useViewport';
import {
  sessionCurrencyCode,
  sessionEmail,
  sessionInvoiceNumber,
  sessionQuoteId,
  sessionTotalAmount,
} from 'modules/session-details';
import st from 'utils/shared-translations';
import QuoteInfo from './quote-info';

import './price-info.css';

const PriceInfo: FC = (): JSX.Element => {
  const intl = useIntl();

  const viewport = useViewPortSize();

  const selectedEmail = useAppSelector(sessionEmail);
  const selectedQuoteId = useAppSelector(sessionQuoteId);
  const selectedSessionInvoiceNumber = useAppSelector(sessionInvoiceNumber);
  const selectedTotalAmount = useAppSelector(sessionTotalAmount);
  const selectedCurrency = useAppSelector(sessionCurrencyCode);

  const referenceNumber = selectedQuoteId || selectedSessionInvoiceNumber;

  const isMobile = viewport.width < 650;

  return (
    <section className="price-info">
      {isMobile ? (
        <Accordion>
          <AccordionItem
            className="price-info__reference"
            heading={<QuoteInfo headerString="reference.number" value={referenceNumber} />}
          >
            <div className="price-info__contact">
              {<QuoteInfo headerString="your.contact.info" value={selectedEmail} />}
            </div>
          </AccordionItem>
        </Accordion>
      ) : (
        <ul className="price-info__list">
          <li className="price-info__reference">
            <QuoteInfo headerString="reference.number" value={referenceNumber} />
          </li>
          <li className="price-info__contact">
            <QuoteInfo headerString="your.contact.info" value={selectedEmail} />
          </li>
        </ul>
      )}

      <MenuSeparator className="price-info__separater" />
      <section className="price-info__total">
        <Typography tag="h1" variant="body-small-strong">
          {intl.formatMessage(st['price.info.total'])}
        </Typography>
        <Typography tag="h1" variant="body-small-strong">
          {intl.formatNumber(selectedTotalAmount, {
            style: 'currency',
            currency: selectedCurrency,
          })}
        </Typography>
      </section>
    </section>
  );
};

export default PriceInfo;
